// src/modules/login/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from '../../components/shared/Form';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';
import { useAuth } from '../auth/AuthContext';
import styled from 'styled-components';
import { useTheme } from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;  /* Full viewport height for vertical centering */
  background-color: ${(props) => props.theme.colors.background};  /* Ensure background color */
`;

const Login = () => {
  const [email, setEmail] = useState(() => {
    // Pre-populate email if remembered
    return localStorage.getItem('rememberEmail') || '';
  });
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(
    !!localStorage.getItem('rememberEmail')
  );
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();  // Use login from AuthContext
  const theme = useTheme();  // Access theme

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await login({ email, password });
      console.log("Result: ",result);
      if (result) {
        if (rememberMe) {
          localStorage.setItem('rememberEmail', email);
        } else {
          localStorage.removeItem('rememberEmail');
        }
        if (result.role === 'employee') {
          // Field employees go straight to their own time portal.
          localStorage.removeItem('redirectUrl');
          navigate('/my-time');
        } else {
          const redirectUrl = localStorage.getItem('redirectUrl');
          if(redirectUrl){
            localStorage.removeItem('redirectUrl');
            navigate(redirectUrl);
          }else{
            navigate('/dashboard');
          }
        }
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      console.error("Login Error: ", err);
      setError('Invalid credentials');
    }
  };

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <h1 style={{ textAlign: 'center', padding: theme.spacing(5) }}>Login</h1>
        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <label style={{ color: theme.colors.textPrimary }}>
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            style={{ marginRight: theme.spacing(1), marginBottom: theme.spacing(1) }}
          />
          Remember me
        </label>
        {error && <p style={{ color: theme.colors.error, paddingBottom: '30px', textAlign: 'center' }}>{error}</p>}
        <Button type="submit">Login</Button>
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <p>
            Forgot password? <a href="/request-reset-password">Reset Password</a>
          </p>
          <p style={{padding: theme.spacing(2)}}>
            Don’t have an account? <a href="/create-user">Create Account</a>
          </p>
        </div>
      </Form>
    </Container>
  );
};

export default Login;
